import type { AppliedFilters } from '~/contracts/common';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

type SearchLinkInput =
  | { cvnaid: string }
  | { filters: Partial<AppliedFilters> };

export default function buildSearchLink(input: SearchLinkInput): string {
  if ('cvnaid' in input && input.cvnaid) {
    const params = new URLSearchParams({ cvnaid: input.cvnaid });

    return `/cars/filters?${params}`;
  }

  return generateSearchLinkFilter({
    filters: 'filters' in input ? input.filters : {}
  });
}
